import { ExternalLink } from "lucide-react";

const FooterCopyright = () => {
  return (
    <div className="border-t border-gray-800 pt-8">
      <div className="flex flex-col items-center">
        {/* Trustpilot Review Widget */}
        <div className="mb-6">
          <div className="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="685a5cea366d801e3d9b04c1" data-style-height="52px" data-style-width="100%">
            <a href="https://www.trustpilot.com/review/biodata360.com" target="_blank" rel="noopener">Review us on <span style={{color: '#00b67a', fontWeight: 600}}>★ Trustpilot</span></a>
          </div>
        </div>
        <div className="w-full text-center">
          <p className="text-gray-400 text-lg">
            &copy; 2025 Biodata360. All rights reserved. | We Also Built This – <a href="https://learnmedx.com/" target="_blank" rel="dofollow" className="underline inline-flex items-center gap-1 hover:opacity-80" style={{color: '#DC2627'}}>
              LearnMedX <ExternalLink className="w-4 h-4" />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FooterCopyright;
